import { CheckCircle2, HelpCircle, XCircle } from "lucide-react";

import { BATCH_STATUS } from "../../../constants/status";

type Status = keyof typeof BATCH_STATUS;

type BadgeConfig = { label: string; icon: typeof CheckCircle2; className: string };

const CONFIG: Record<Status, BadgeConfig> = {
  [BATCH_STATUS.ACTIVE]: {
    label: "Ativo",
    icon: CheckCircle2,
    className: "bg-emerald-50 text-emerald-700 border-emerald-200",
  },
  [BATCH_STATUS.UNDONE]: {
    label: "Desfeito",
    icon: XCircle,
    className: "bg-rose-50 text-rose-700 border-rose-200",
  },
};

const UNKNOWN_CONFIG: BadgeConfig = {
  label: "Desconhecido",
  icon: HelpCircle,
  className: "bg-slate-50 text-slate-600 border-slate-200",
};

export function BatchStatusBadge({ status }: { status: Status | string }) {
  const cfg = CONFIG[status as Status] ?? UNKNOWN_CONFIG;
  const Icon = cfg.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${cfg.className}`}
    >
      <Icon className="h-3.5 w-3.5 shrink-0" />
      {cfg.label}
    </span>
  );
}
